import { Component, Injector, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { MessagePlaceholder } from 'src/app/common/models/placeholder';
import { RadLocationTypeService } from '../../services/rad-location-type.service';
import { YesNoDialogComponent } from 'src/app/controls/yes-no-dialog/yes-no-dialog.component';
import { RadInterlock } from 'src/app/components/catalogs/rad-monitor/rad-monitor/rad-interlock';
import { RadLocationInterlockRelation } from 'src/app/components/catalogs/rad-monitor/rad-monitor/rad-location-interlock-relation';
import { RadInterlockService } from '../../services/rad-interlock.service';


@Component({
  selector: 'rad-monitor-add-edit-rad-interlock',
  templateUrl: './add-edit-rad-interlock.component.html',
  styleUrls: ['./add-edit-rad-interlock.component.scss']
})
export class RadMonitorAddEditRadInterlockComponent extends BaseComponent implements OnInit {

  radInterlocks?: RadInterlock[];
  radInterlocksFiltered?: RadInterlock[];
  radInterlocks$!: Observable<RadInterlock[]>;
  radInterlocksSubs!: Subscription;

  radLocationInterlockRelations?: RadLocationInterlockRelation[];
  radLocationInterlockRelationsFiltered?: RadLocationInterlockRelation[];
  radLocationInterlockRelations$!: Observable<RadLocationInterlockRelation[]>;
  radLocationInterlockRelationsSubs!: Subscription;

  public displayedColumnsRadManagement: string[] = ['name', 'options'];
  public dataSourceRadManagement: MatTableDataSource<RadManagement> = new MatTableDataSource();

  public name!: string;

  constructor(
    protected override injector: Injector,
    private service: RadInterlockService
  ) {
    super(injector);
  }

  ngOnInit() {
    this.loadRadLocationInterlockRelations();
  }

  loadRadInterlocks() {
    this.radInterlocks$ = this.store.select(state => state.RadInterlock.data);
    this.radInterlocksSubs = this.radInterlocks$.subscribe(data => {
      if (data?.length) {
        this.radInterlocks = data;
        this.radInterlocks?.map(t => {
          t.deleteDisabled = this.radLocationInterlockRelations?.some(l => l.radInterlockId == t.id);
          t.preName = t.name;
        });
        this.dataSourceRadManagement = new MatTableDataSource(this.radInterlocks);
      }
    });
  }

  loadRadLocationInterlockRelations() {
    this.radLocationInterlockRelations$ = this.store.select(state => state.RadLocationInterlockRelation.data);
    this.radLocationInterlockRelationsSubs = this.radLocationInterlockRelations$.subscribe(data => {
      if (data?.length) {
        this.radLocationInterlockRelations = data;
        this.loadRadInterlocks();
      }
    });
  }

  create() {
    if (this.name) {
      const radManagement: RadManagement = {
        name: this.name,
        preName: this.name,
        editing: false
      };
      this.service.CreateRadInterlock(radManagement).toPromise();
    } else {
      this.alert.message('RadManagement_NotBlank', [new MessagePlaceholder('{what}', 'Interlock')]);
    }
  }

  saveChanges(radManagement: RadManagement) {
    if (radManagement.name && radManagement.id) {
      radManagement.name = radManagement.preName;
      this.service.UpdateRadInterlock(radManagement.id, radManagement).toPromise();
      radManagement.editing = false;
    } else {
      this.alert.message('RadManagement_NotBlank', [new MessagePlaceholder('{what}', 'Interlock')]);
    }
  }

  delete(radManagement: RadManagement) {
    const dialog = this.dialog.open(YesNoDialogComponent, {
      width: "500px", data: {
        message: 'Are you sure you want to Delete <b>' + radManagement.name + '</b> ?'
        , icon: "question",
      },
    });
    dialog.afterClosed().subscribe(async (data) => {
      if (data && radManagement.id) {
        this.service.DeleteRadInterlock(radManagement.id).toPromise();
      }
    });
  }

  setEditing(radManagement: RadManagement) {
    this.dataSourceRadManagement.data.map(x => {
      x.editing = false;
    });
    radManagement.editing = true;
  }

  discardChanges(radManagement: RadManagement) {
    radManagement.preName = radManagement.name;
    radManagement.preDefaultValue = radManagement.defaultValue;
    radManagement.editing = false;
  }

}

class RadManagement {
  id?: number;
  name?: string;
  preName?: string;
  status?: number;
  editing?: boolean;
  defaultValue?: string;
  preDefaultValue?: string;
}
